import { render, staticRenderFns } from "./ChildSideBar.vue?vue&type=template&id=10c03f40&scoped=true&"
import script from "./ChildSideBar.vue?vue&type=script&lang=js&"
export * from "./ChildSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ChildSideBar.vue?vue&type=style&index=0&id=10c03f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c03f40",
  null
  
)

export default component.exports